import paymentType from "../types/paymentType";
import ApplicationInfo from "../../../../../../../core/interfaces/applications/ApplicationInfo";

type PaymentInfoSubgroup = {
  name: string;
  applications: ApplicationInfo[];
};

type PaymentInfoSubgroups = {
  bachelor_specialist: PaymentInfoSubgroup;
  master: PaymentInfoSubgroup;
};

class PaymentInfo {
  subgroups: PaymentInfoSubgroups = {
    bachelor_specialist: {
      name: "БАКАЛАВРИАТ/СПЕЦИАЛИТЕТ",
      applications: [],
    },
    master: {
      name: "МАГИСТРАТУРА",
      applications: [],
    },
  };

  name: paymentType;

  viewedName: string;

  disabled: boolean;

  constructor(name: paymentType, applications: ApplicationInfo[] = []) {
    const info = {
      paid: "Платное",
      budget: "Бюджет",
      draft: "Черновики",
    } as Record<paymentType, string>;

    this.name = name;
    this.viewedName = info[name];
    this.disabled = applications.length === 0;

    applications
      .sort((a, b) => a.priority - b.priority)
      .forEach((application) => {
        if (application.level === "Магистратура") {
          this.subgroups.master.applications.push({
            ...application,
            priority: this.subgroups.master.applications.length + 1,
          });
        } else {
          this.subgroups.bachelor_specialist.applications.push({
            ...application,
            priority: this.subgroups.bachelor_specialist.applications.length + 1,
          });
        }
      });
  }

  get applications(): ApplicationInfo[] {
    return [
      ...this.subgroups.bachelor_specialist.applications,
      ...this.subgroups.master.applications,
    ];
  }
}

export default PaymentInfo;
